import Config from '@/config'

export const isProduction = () => {
	if (process.env.REACT_APP_HOST_TYPE) {
		return ['pre', 'pro'].includes(process.env.REACT_APP_HOST_TYPE)
	}
	return process.env.NODE_ENV === 'production'
}

export const isCompositorEnabled = (email, subfamily, application) => {
	const compositorConfig = Config.getInstance().getConfig(`compositor`)
	if (!compositorConfig) return false
	return compositorConfig.enabledEmails.includes(email) &&
		(!subfamily || compositorConfig.enabledSubfamilies.includes(subfamily)) &&
		(!application || compositorConfig.enabledApplications.includes(application))
}

export const getURL = (url, subdomain = null) => {
	const apiHost = Config.getInstance()?.getConfig(`apiHost`)
	if (!subdomain && subdomain !== '') {
		if (apiHost) {
			return url.replace(document.location.host.split('.').slice(1).join('.'), apiHost)
		} else {
			return url
		}
	} else {
		return document.location.protocol + '//' + [
			...(subdomain ? [subdomain] : []),
			...(apiHost ? [apiHost] : document.location.host.split('.').slice(1))
		].join('.') + url
	}
}

export const getServiceURL = (service) => {
	const path = Config.getInstance().getConfig(`endpoints.${service}.url`)
	const subdomain = Config.getInstance().getConfig(`endpoints.${service}.subdomain`)
	return getURL(path, subdomain)
}

export const getAssetURL = (path) => getURL(path, 'packer.')